function SpecialCharactersEmoji(editor) {
    editor.plugins.get('SpecialCharacters')
        .addItems('Emoji', [
            { title: 'Emoji 1',  character: '😀' },
            { title: 'Emoji 2',  character: '😁' },
            { title: 'Emoji 3',  character: '😂' },
            { title: 'Emoji 4',  character: '😃' },
            { title: 'Emoji 5',  character: '😉' },
            { title: 'Emoji 6',  character: '😋' },
            { title: 'Emoji 7',  character: '😎' },
            { title: 'Emoji 8',  character: '😍' },
            { title: 'Emoji 9',  character: '😗' },
            { title: 'Emoji 10', character: '🤗' },
            { title: 'Emoji 11', character: '🤔' },
            { title: 'Emoji 12', character: '😣' },
            { title: 'Emoji 13', character: '😫' },
            { title: 'Emoji 14', character: '😴' },
            { title: 'Emoji 15', character: '😌' },
            { title: 'Emoji 16', character: '🤓' },
            { title: 'Emoji 17', character: '😛' },
            { title: 'Emoji 18', character: '😜' },
            { title: 'Emoji 19', character: '😠' },
            { title: 'Emoji 20', character: '😇' },
            { title: 'Emoji 21', character: '😷' },
            { title: 'Emoji 22', character: '😈' },
            { title: 'Emoji 23', character: '👻' },
            { title: 'Emoji 24', character: '😺' },
            { title: 'Emoji 25', character: '😸' },
            { title: 'Emoji 26', character: '😹' },
            { title: 'Emoji 27', character: '😻' },
            { title: 'Emoji 28', character: '😼' },
            { title: 'Emoji 29', character: '😽' },
            { title: 'Emoji 30', character: '🙀' },
            { title: 'Emoji 31', character: '🙈' },
            { title: 'Emoji 32', character: '🙉' },
            { title: 'Emoji 33', character: '🙊' },
            { title: 'Emoji 34', character: '👼' },
            { title: 'Emoji 35', character: '👮' },
            { title: 'Emoji 36', character: '🕵' },
            { title: 'Emoji 37', character: '💂' },
            { title: 'Emoji 38', character: '👳' },
            { title: 'Emoji 39', character: '🎅' },
            { title: 'Emoji 40', character: '👸' },
            { title: 'Emoji 41', character: '👰' },
            { title: 'Emoji 42', character: '👲' },
            { title: 'Emoji 43', character: '🙍' },
            { title: 'Emoji 44', character: '🙇' },
            { title: 'Emoji 45', character: '🚶' },
            { title: 'Emoji 46', character: '🏃' },
            { title: 'Emoji 47', character: '💃' },
            { title: 'Emoji 48', character: '⛷' },
            { title: 'Emoji 49', character: '🏂' },
            { title: 'Emoji 50', character: '🏌' },
            { title: 'Emoji 51', character: '🏄' },
            { title: 'Emoji 52', character: '🚣' },
            { title: 'Emoji 53', character: '🏊' },
            { title: 'Emoji 54', character: '⛹' },
            { title: 'Emoji 55', character: '🏋' },
            { title: 'Emoji 56', character: '🚴' },
            { title: 'Emoji 57', character: '👫' },
            { title: 'Emoji 58', character: '💪' },
            { title: 'Emoji 59', character: '👈' },
            { title: 'Emoji 60', character: '👉' },
            { title: 'Emoji 61', character: '👆' },
            { title: 'Emoji 62', character: '🖕' },
            { title: 'Emoji 63', character: '👇' },
            { title: 'Emoji 64', character: '🖖' },
            { title: 'Emoji 65', character: '🤘' },
            { title: 'Emoji 66', character: '🖐' },
            { title: 'Emoji 67', character: '👌' },
            { title: 'Emoji 68', character: '👍' },
            { title: 'Emoji 69', character: '👎' },
            { title: 'Emoji 70', character: '✊' },
            { title: 'Emoji 71', character: '👊' },
            { title: 'Emoji 72', character: '👏' },
            { title: 'Emoji 73', character: '🙌' },
            { title: 'Emoji 74', character: '🙏' },
            { title: 'Emoji 75', character: '🐵' },
            { title: 'Emoji 76', character: '🐶' },
            { title: 'Emoji 77', character: '🐇' },
            { title: 'Emoji 78', character: '🐥' },
            { title: 'Emoji 79', character: '🐸' },
            { title: 'Emoji 80', character: '🐌' },
            { title: 'Emoji 81', character: '🐛' },
            { title: 'Emoji 82', character: '🐜' },
            { title: 'Emoji 83', character: '🐝' },
            { title: 'Emoji 84', character: '🍉' },
            { title: 'Emoji 85', character: '🍄' },
            { title: 'Emoji 86', character: '🍔' },
            { title: 'Emoji 87', character: '🍤' },
            { title: 'Emoji 88', character: '🍨' },
            { title: 'Emoji 89', character: '🍪' },
            { title: 'Emoji 90', character: '🎂' },
            { title: 'Emoji 91', character: '🍰' },
            { title: 'Emoji 92', character: '🍾' },
            { title: 'Emoji 93', character: '🍷' },
            { title: 'Emoji 94', character: '🍸' },
            { title: 'Emoji 95', character: '🍺' },
            { title: 'Emoji 96', character: '🌍' },
            { title: 'Emoji 97', character: '🚑' },
            { title: 'Emoji 98', character: '⏰' },
            { title: 'Emoji 99', character: '🌙' },
            { title: 'Emoji 100', character: '🌝' },
            { title: 'Emoji 101', character: '🌞' },
            { title: 'Emoji 102', character: '⭐' },
            { title: 'Emoji 103', character: '🌟' },
            { title: 'Emoji 104', character: '🌠' },
            { title: 'Emoji 105', character: '🌨' },
            { title: 'Emoji 106', character: '🌩' },
            { title: 'Emoji 107', character: '⛄' },
            { title: 'Emoji 108', character: '🔥' },
            { title: 'Emoji 109', character: '🎄' },
            { title: 'Emoji 110', character: '🎈' },
            { title: 'Emoji 111', character: '🎉' },
            { title: 'Emoji 112', character: '🎊' },
            { title: 'Emoji 113', character: '🎁' },
            { title: 'Emoji 114', character: '🎗' },
            { title: 'Emoji 115', character: '🏀' },
            { title: 'Emoji 116', character: '🏈' },
            { title: 'Emoji 117', character: '🎲' },
            { title: 'Emoji 118', character: '🔇' },
            { title: 'Emoji 119', character: '🔈' },
            { title: 'Emoji 120', character: '📣' },
            { title: 'Emoji 121', character: '🔔' },
            { title: 'Emoji 122', character: '🎵' },
            { title: 'Emoji 123', character: '🎷' },
            { title: 'Emoji 124', character: '💰' },
            { title: 'Emoji 125', character: '🖊' },
            { title: 'Emoji 126', character: '📅' },
            { title: 'Emoji 127', character: '✅' },
            { title: 'Emoji 128', character: '❎' },
            { title: 'Emoji 129', character: '💯' }
        ], {
            label: 'Emoticons'
        });
}

export default SpecialCharactersEmoji;
